import PatientOverviewMedicationPrescription from 'dashboard/templates/views/Patient/Medication/PatientOverviewMedicationPrescription';

export default {
  path: 'prescription',
  name: 'PatientRecordMedicationPrescription',
  component: PatientOverviewMedicationPrescription,
  meta: {
    // title: 'Patient Record - Medication - Prescription',
    // title: t => `${t('patient.patientRecord')} - ${t('screens.medicationAdherenceScreen', 'app_mobile')} - ${t('medication.prescription')}`,
    // title: 'Medication - Prescription',
    title: t => `${t('screens.medicationAdherenceScreen', 'app_mobile')} - ${t('medication.prescription')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
